export default function Logo({ className = "h-9 w-auto", light = false }) {
  return (
    <img
      src="/assets/obled-logo.png"
      alt="Obled Corporation"
      className={className}
      style={light ? { filter: "brightness(0) invert(1)" } : undefined}
    />
  );
}
